















































































import * as VueGoogleMaps from 'vue2-google-maps';
import { Component, Prop, Vue } from 'vue-property-decorator';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBjK-fi1-SU__a6gFyl6nYLmLP45Aqim54',
    v: '3.35',
  },
});

interface Position {
  lat: number;
  lng: number;
}

interface Shop {
  name: string;
  address: string[];
  position: Position;
  icon?: string;
  telephone?: string;
  website?: string;
}

interface Size {
  height: number;
  width: number;
}

interface Icon {
  url: string;
  size?: Size;
  scaledSize?: Size;
}

export interface Marker {
  title?: string;
  icon?: Icon;
  position: Position;
  content?: Shop;
}

interface Map {
  zoom: number;
  center: Position;
}

interface InfoWindow {
  position: Position;
  content: Shop;
  marker: number;
  open: boolean;
}

@Component({
  data: () => ({
    map: {
      zoom: 6,
      center: {
        lat: 50,
        lng: 8,
      },
    },
    search: '',
    marker: null,
    info: {
      open: false,
      position: null,
      content: null,
      marker: null,
      options: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
    },
    currentMidx: null,
    show: false,
  }),
})
export default class Location extends Vue {
  @Prop({
    required: true,
    type: Array,
  })
  private shops!: Shop[];
  private map!: Map;
  private marker!: Marker;
  private search!: string;
  private info!: InfoWindow;
  private show!: boolean;

  public mounted() {
    Vue.$gmapApiPromiseLazy().then(() => {
      this.show = true;
    });
  }

  public onSearchRequest() {
    this.geocoder.geocode({ address: this.search }, this.onSearchRequestResult);
  }

  public onMarkerClick(marker: Marker, index: number) {
    if (!marker.content) {
      return; // No Shop defined
    }
    this.info.position = marker.position;
    this.info.content = marker.content;
    if (this.info.marker === index) {
      this.info.open = !this.info.open;
    } else {
      this.info.marker = index;
      this.info.open = true;
    }
  }

  private onSearchRequestResult(results: any[], status: string) {
    if (status === 'OK') {
      const result = results[0]; // Take first result
      const position = result.geometry.location;
      this.marker = { position };
      this.map.zoom = 10;
      this.map.center = position;
    } else if (status === 'ZERO_RESULTS') {
      Vue.toasted.show(`Konnte nicht gefunden werden: ${this.search}`, {
        theme: 'bubble',
        position: 'bottom-center',
        type: 'error',
        duration: 3000,
      });
    } else {
      // tslint:disable-next-line:no-console
      console.log(status, results); // TODO: Toast - Unbekannter Fehler
    }
  }

  private get markers() {
    const f = 65;
    const tmp: Marker[] = this.shops.map((s) => ({
      title: s.name,
      icon: {
        url: s.icon || require('../assets/icon_map_shop.png'),
        scaledSize: this.size(0.41 * f, 0.58 * f),
      },
      position: s.position,
      content: s,
    }));
    if (this.marker) {
      tmp.push(this.marker);
    }
    return tmp;
  }

  private get geocoder() {
    return new this.google.maps.Geocoder();
  }

  private point(x: number, y: number) {
    return new this.google.maps.Point(x, y);
  }

  private size(width: number, height: number) {
    const a = new this.google.maps.Size(width, height, 'px', 'px');
    return a;
  }

  private get google() {
    return window.google;
  }
}
